export enum TagTypeEnum {
    FixedHtmlContentTemplate
}

export interface Tag {
    id?: string,
    name: string
}

export interface TagOption {
    id: string,
    name: string
    selected: boolean
}
